var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-youtube';
                    var viewUrl = 'sprite.svg#view-icon-youtube';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-youtube#icon-youtube';
                            viewUrl = 'sprite.svg?icon-youtube#view-icon-youtube';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16.7 16.7',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };